import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useCurrentUserOrNullIfAnonymous } from 'hooks/useCurrentUser';
import { useIsSystemAdmin } from 'hooks/useRoleCheck';
import useUnreadNotificationCount from 'hooks/useUnreadNotificationCount';
import EpdRoutes from 'routes/EpdRoutes';
import HeaderSquareButton from './HeaderSquareButton';

const HeaderNotifications: React.FC = () => {
  const history = useHistory();
  const currentUser = useCurrentUserOrNullIfAnonymous();
  const isSystemAdmin = useIsSystemAdmin();
  const unread = useUnreadNotificationCount();

  // Hide the bell entirely in impersonate mode so notifications addressed to
  // the impersonated user are not visually consumed by the impersonator
  // (per US 16379 discussion point #3).
  const isImpersonating = !!currentUser?.impersonatedBy;
  // Test feature: limit visibility to System Administrators for now.
  if (!currentUser || isImpersonating || !isSystemAdmin) {
    return null;
  }

  const hasUnread = (unread?.total ?? 0) > 0;

  return (
    <HeaderSquareButton icon="pi pi-bell" onClick={() => history.push(EpdRoutes.notifications)}>
      {hasUnread && <NotificationMark />}
    </HeaderSquareButton>
  );
};

export default HeaderNotifications;

const NotificationMark = styled.div`
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.statusLabelRedText};
  right: 8px;
  top: 6px;
`;
